import {getRoot, onPatch, types} from "mobx-state-tree";
import {persistStore, PersistStore} from "./PersistStore";
import {treeMapResultsStore, treeMapStore, TreeMapStore} from "./layouts/TreeMapStore";
import {circlePackStore, CirclePackStore} from "./layouts/CirclePackStore";
import {resultStore, ResultStore} from "./ResultStore";

import FirebaseModel from "../models/FirebaseModel";
import {InteractionsStore, interactionsStore} from "./InteractionsStore";
import moodBoardData from "../assets/moodboard-data";
import programElements from "../assets/program-elements";

const SectionStore = types
    .model('SectionStore', {
        scrollProgress: types.number,
        isVisible: types.boolean,
    })
    .actions(self => ({
        setScrollProgress(value) {
            self.scrollProgress = value;
        },
        setVisible(value) {
            self.isVisible = value;
        },
    })).views(self => ({
        get scrollState() {
            if (!self.isVisible) {
                return 'OFF-SCREEN';
            }
            return `${self.scrollProgress}`;
        }
    }));

const fbModel = new FirebaseModel(persistStore);

export const RootStore = types
    .model('RootStore', {
        scrollProgress: types.number,
        activeSections: types.map(types.string),
        sections: types.map(SectionStore),
        selectedIndices: types.array(types.number),
        persistStore: types.maybeNull(PersistStore),
        treeMapStore: types.maybeNull(TreeMapStore),
        treeMapResultsStore: types.maybeNull(TreeMapStore),
        circlePackStore: types.maybeNull(CirclePackStore),
        resultStore: types.maybeNull(ResultStore),
        interactionsStore: types.maybeNull(InteractionsStore),
    })
    .actions(self => ({
        setActiveSection(sectionGroup, value) {
            self.activeSections.set(sectionGroup, value);
        },

        selectIndex(index, selected) {
            console.log("selectIndex", index, selected)
            if (selected) {
                self.selectedIndices.push(index);
            } else {
                const idx = self.selectedIndices.indexOf(index);
                if (idx > -1) {
                    self.selectedIndices.splice(idx, 1);
                }
            }
        },
        setScrollProgress(value) {
            self.scrollProgress = value;
        },
        createSection(key) {
            // console.log(selection);
            let n = SectionStore.create({
                scrollProgress: 0,
                isVisible: false,
            });
            self.sections.set(key, n);
            return n;
        },
        setCardFlipSize(index, width, height) {
            self.interactionsStore.setCardFlipSize(index, width, height);
            if (index === 3) {//index for LC (life on campus)
                self.circlePackStore.setSize(width, height);
            }
        }

    }))
    .views(self => ({
        activeSection(sectionGroup) {
            return self.activeSections.get(sectionGroup);
        },
        getFbModel() {
            return fbModel;
        }
    }))
    .volatile(self => ({
        user: null
    }));

export const rootStore = RootStore.create({
    scrollProgress: 0,
    sections: {},
    selectedIndices: [0],
    treeMapStore,
    treeMapResultsStore,
    circlePackStore,
    persistStore,
    resultStore,
    interactionsStore,
});
const updateCirclePack = () => {
    const selectedMoodBoardKeys = persistStore.selectedMoodBoardKeys;
    // console.log('updateCirclePack', selectedMoodBoardKeys);
    moodBoardData.forEach((image, i) => {
        let score = resultStore.getScore('moodboard', image.key);
        // console.log(image.key, score, selectedMoodBoardKeys);
        if (selectedMoodBoardKeys.indexOf(image.key) >= 0) {//include what the user just said or their circle won't show at all
            score++;
        }
        circlePackStore.setNodeSize(image.key, score);
    });
};

const updateResultsTreeMap = () => {
    // console.log('updateResultsTreeMap...');
    programElements.forEach((group, i) => {
        group.elements.forEach((programElement, i) => {
            const key = programElement.id;
            let score = resultStore.getScore('program', key);
            score += persistStore.getScore('program', key);
            treeMapResultsStore.setNodeSize(key, score);
            // console.log('treeMapResultsStore.setNodeSize(', key, score);

        });
    });
};

onPatch(persistStore, ({op, path, value}) => {
    console.log('persistStore', op, path, value);
    // circlePackStore.setNodeSize(image.key, );
    if (op === 'replace') {
        const [, field, id, prop] = path.split('/');
        if (field === 'programRanks') {
            if (prop === 'score') {
                treeMapStore.setNodeSize(id, value);
                setTimeout(updateResultsTreeMap, 1);//hack to ensure value has been applied
            }
        }
        if (field === 'moodBoardSelections' && prop === 'active') {
            setTimeout(updateCirclePack, 1);//hack to ensure value has been applied
        }
    }
});

onPatch(resultStore, ({op, path, value}) => {
    // console.log(`resultStore PATCH ${op} ${path} ${value}`);
    //resultStore PATCH add /rankings/program/scores/EWC_3
    if (op === 'add') {
        const [, field, group, field2, id] = path.split('/');
        if (field === 'rankings' && group === 'program' && field2 === 'scores') {
            treeMapResultsStore.setNodeSize(id, value);
        }
    }
    if (op === 'replace') {
        const [, field, id, prop] = path.split('/');

    }
});
